import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import Drawer from '@mui/material/Drawer';
import Algo from './Algo.js'
import LaunchIcon from '@mui/icons-material/Launch';

function AlgoDrawer(props) {

    const [drawerOpen, setDrawerOpen] = useState(false);


    return (
        <div>
            <Link className="drawer-link" onClick={() => setDrawerOpen(true)}>{props.link} <LaunchIcon fontSize='small' /></Link>
            <Drawer
                anchor={'top'}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
            >
                <div style={{ padding: '20px' }}>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                    <br></br>

                    <Algo tab={props.tab} userId={props.userId} planId={props.planId} accountId={props.accountId} mobileView={props.mobileView} algoId={props.algoId} role={props.role} />
                    <br></br>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                </div>
            </Drawer>
        </div>
    );
}

export default AlgoDrawer;